import { humanizeNameLowercase } from '@utils/capitalize';
import { DesignSizeTypeSetCategory } from 'graphql/generated/types.autogenerated';

export default function getButtonText(category?: DesignSizeTypeSetCategory, simplify = false) {
  if (category) {
    return `Start from ${getCategoryName(category, simplify)} set`;
  }

  return 'Start from set';
}

const SOCIAL_CATEGORIES = [DesignSizeTypeSetCategory.SOCIAL_CAMPAIGN, DesignSizeTypeSetCategory.SOCIAL_POST];

function getCategoryName(category: DesignSizeTypeSetCategory, simplify: boolean) {
  if (simplify && SOCIAL_CATEGORIES.includes(category)) {
    return 'social';
  }

  return humanizeNameLowercase(category);
}
